import PropTypes from 'prop-types'
import React from 'react'
import classes from './ElementInfo.module.scss'

export class ElementInfo extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ])
  }

  render () {
    const {
      children,
      className,
      icon
    } = this.props

    let compClassName = classes.elementInfo
    if (className) compClassName += ' ' + className

    return (
      <span className={compClassName}>
        {icon &&
          <span className={classes.iconWrapper}>
            {icon}
          </span>
        }
        {children}
      </span>
    )
  }
}

export default ElementInfo

